<template>
    <div class="fullscreen-box">
        <div class="fullscreen-box--outer" :style="{ overflow: view == 2 ? 'hidden' : 'auto' }">
            <div class="fullscreen-box--inner">
                <div class="fullscreen-box--container">
                    <div class="container">
                        <div class="fullscreen-box--content">
                            <transition name="fadeInUp">
                                <register-form v-show="view == 4" :view="view"></register-form>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RegisterForm from './partials/RegisterForm.vue'

    export default {
        components: { RegisterForm },
        computed: {
            view () {
                return this.$store.getters.loginForm.view
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_colors.scss';
    @import '../../assets/scss/_guest.scss';
    @import '../../assets/css/transitions.css';

    .fullscreen-box{
        background-image: url('../../assets/img/ftn-home-bg.jpg');
    }
</style>


// WEBPACK FOOTER //
// src/components/register/Register.vue